import { Typography } from "@mui/material";

/** Common style element for main headings */
export function Title({ children, ...restProps }) {
  return (
    <Typography variant="h6" {...restProps}>
      {children}
    </Typography>
  );
}
